<template>
  <div class="page">
    <div class="card">
      <base-info>
        <base-info-item label="Designer ID">33451123</base-info-item>
        <base-info-item label="Season">19SS</base-info-item>
        <base-info-item label="Color Code">Ferw</base-info-item>
      </base-info>
    </div>
    <div class="card">
      <el-form ref="editForm" :model="formData" :rules="formRules" label-width="160px">
        <el-row>
          <el-col :md="24" :lg="18" :xl="12">
            <el-form-item label="SPU Name" prop="spuName">
              <el-input v-model.trim="formData.spuName" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="Brand" prop="brandId">
              <el-select filterable no-match-text="no match data" v-model="formData.brandId" style="width: 100%">
                <el-option v-for="item in brandList" :key="item.brand_id" :label="item.english_name" :value="item.brand_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Category" prop="categorySelect">
              <el-cascader
                style="width: 100%"
                :options="categoryList"
                :props="{ value: 'categoryId', label: 'name' }"
                v-model="formData.categorySelect"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="Description(商品描述)" prop="spuDescription">
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" v-model.trim="formData.spuDescription"></el-input>
            </el-form-item>
            <el-form-item label="Composition(成分)" prop="composition">
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" v-model.trim="formData.composition"></el-input>
            </el-form-item>
            <el-form-item label="Dimension(尺寸说明)" prop="dimension">
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" v-model.trim="formData.dimension"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" @click="submitForm">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Form',
  data() {
    return {
      formData: {
        spuId: null,
        spuName: '',
        boutiqueImg: [],
        boutiqueImgMapping: [],
        brandId: null,
        categorySelect: [],
        categoryId: null,
        category: [],
        composition: '',
        dimension: '',
        spuDescription: '',
        modelImg: [],
        streetImg: [],
      },
      formRules: {
        spuName: [{ required: true, message: '请输入SPU Name', trigger: 'blur' }],
        brandId: [{ required: true, message: '请选择品牌', trigger: 'blur' }],
        categorySelect: [{ required: true, message: '请选择分类', trigger: 'blur' }],
        spuDescription: [{ required: true, message: '请填写商品描述', trigger: 'blur' }],
        boutiqueImgMapping: [{ required: true, message: '请上传图片', trigger: 'blur' }],
      },
      brandList: [],
      categoryList: [],
    };
  },
  created() {},
  methods: {
    submitForm() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.saveSpu();
        } else {
          this.$message('请填充所有必填信息');
        }
      });
    },
    saveSpu() {},
  },
};
</script>

<style scoped></style>
